module.exports = __webpack_public_path__ + "img/resolve.89392d67.png";